import { config } from "../../../common/config";

export function getLegacyRegion() {
    return config.legacyRegion ?? "au";
}
